import React, { useState, useEffect } from "react";
import CommonCard from "../common/commonCard";
import Header from "../common/header";
import { Container, Row, Col, Button } from "react-bootstrap";
import FormCard from "../common/formCard";
import TimeLine from "../common/timeline";
import {
  formatToSpanishTimeZone,
  addDaysAndFormat,
} from "../../utils/formatDate";
import { downloadFileDefault } from "../../utils/downloadPdf";
import PopUpNotification from "../specific/popUpNotification";
import PopUpTimeLine from "../specific/popUpTimeLine";
import { useLocation } from "react-router-dom";
import { GetComapanyService } from "../../Services/companyService";
import CustomTable from "../common/table";
import { useTranslation } from "react-i18next";
import MessagePopUp from "../common/messagePopUp";

const ConsultIncident = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showPlayPopup, setShowPlayPopup] = useState(false);
  const [textBody, setTextBody] = useState(null);
  const [activity, setActivity] = useState(null);
  const [data, setData] = useState(null);
  const location = useLocation();
  const [key, setKey] = useState(Date.now()); // Nueva clave estado
  const [incidentData, setIncidentData] = useState(location.state?.data || {});
  const [docsFromIncident, setDocsFromIncidents] = useState([]);
  const [t] = useTranslation("publicIncident")
  const [tIncidents] = useTranslation("incidents")

  useEffect(() => {
    incidentData.incidentActivities.forEach((activity) => {
      if (activity.incidentActivityStateId === "65e4955b-9814-400a-a3b8-0331f9d418dd") {
        setTextBody(
          `${t("checkIncident.actionRequired")} '${activity.incidentActivityType}'`
        );
        setActivity(activity);
        setShowPopup(true);
      }
    });
  }, [incidentData.incidentActivities]);

  useEffect(() => {
    setIncidentData(location.state?.data || {}); 
    setKey(Date.now()); // Actualizar la clave cada vez que los datos cambian
  }, [location]);

  const handleButtonClick = () => {
    setShowPopup(false);
    // Haz cualquier otra cosa que quieras aquí, y luego muestra el segundo popup
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleButtonAudioPopUpMessageClick = () => {
    setShowPlayPopup(false);
  };


  // useEffect(() => {
  //   setShowPopup(true); // Muestra el pop-up cuando el componente se monta
  // }, []);

  useEffect(() => {
    const getCompany = async () => {
      try {
        const companyData = await GetComapanyService(incidentData.companyId);
        setData(companyData);
      } catch (error) {
        console.error(error);
      }
    };
    getCompany();
  }, [incidentData.companyId]); // Se ejecutará cada vez que `id` cambie

  const downloadDoc = (mimeType, fileData, incidentKey) => {
    const blob = b64toBlob(fileData, mimeType);
    const downloadLink = document.createElement("a");
    const fileName = `${incidentKey}_${t("checkIncident.docFileName")}`;
    downloadLink.download = fileName;
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.click();
  };

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  //Formatemos los datos de incident para obtener todos los docs (Activities docs + incident doc).
  useEffect(() => {
    let incidentDataArray = [];
    incidentDataArray.push(incidentData);

    let docsActivities = [];

    if (incidentDataArray[0].incidentActivities) {
      docsActivities = incidentDataArray[0].incidentActivities
        .filter(activity => activity.fileData && activity.fileName)
        .map(activity => {
          return {
            ...activity,
            incidentKey: incidentDataArray[0].incidentKey,
            createdAt: formatToSpanishTimeZone(activity.createdAt)
          };
        });
    }

    if (incidentDataArray[0].fileData != null) {
      let docFromIncident = {
        createdAt: formatToSpanishTimeZone(incidentDataArray[0].createdAt),
        fileName: incidentDataArray[0].fileName,
        fileData: incidentDataArray[0].fileData,
        incidentActivityType: `${tIncidents("consultIncident.activityCreation")}`,
        incidentKey: incidentDataArray[0].incidentKey

      }

      docsActivities.push(docFromIncident);

    }

    setDocsFromIncidents(docsActivities);

  }, [incidentData]);

  const columnHeaders = [
    `${tIncidents("incidentActivityTable.createdAt")}`,
    `${tIncidents("incidentActivityTable.fileName")}`,
    `${tIncidents("incidentActivityTable.incidentActivityType")}`,
  ];

  const fieldsToShow = [
    "createdAt",
    "fileName",
    "incidentActivityType"
  ];

  const optionArrays = [
    []
  ];

  return (
    <div key={key}>
      {activity && (
        <>
          <PopUpNotification
            show={showPopup}
            handleClose={() => setShowPopup(false)}
            textBody={textBody}
            title={t("actionRequiredPopUp.title")}
            buttonText={t("actionRequiredPopUp.button")}
            onClickButton={handleButtonClick}
          />
          <PopUpTimeLine
            show={showModal}
            onHide={handleModalClose}
            item={activity}
            activityType={activity.incidentActivityType}
            readOnly={true}
            user={true}
            incidentKey={incidentData.key}
          />
        </>
      )}
      <MessagePopUp
        show={showPlayPopup}
        handleClose={() => setShowPlayPopup(false)}
        title={tIncidents("incidentAudioPopup.title")}
        textBody={
          incidentData.audio ? (
            <audio controls controlsList="nodownload" className="mt-2 mb-2">
              <source src={`${incidentData.audio}`} type="audio/wav" />
              {tIncidents("incidentAudioPopup.noSupport")}
            </audio>
          ) : (
            <p>{tIncidents("incidentAudioPopup.noAudioAvailable")}</p>
          )
        }
        buttonText={tIncidents("incidentAudioPopup.acceptButton")}
        onClickButton={handleButtonAudioPopUpMessageClick}
      />
      <Header
        privateWeb={true}
        publicIncident={true}
        imageMimeType={data && data.imageMimeType}
        imageData={data && data.imageData}
        companyId={data && data.companyId}
      />
      <Container fluid>
        <Row>
          <Col className='d-flex mb-5'>
            <Row>
              {/* Columna principal para los Col md={8} */}
              <Col md={7}>
                <Row>
                  {/* Primer CommonCard */}
                  <Col md={12}>
                    <CommonCard
                      title={tIncidents("dataForm.title")}
                      icon={"FaDatabase"}
                      incidentId={incidentData.incidentKey}
                      incidentData={incidentData}
                    >
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.company")}
                            text={incidentData.company}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.workPlace")}
                            type={"text"}
                            text={incidentData.workPlace ? incidentData.workPlace : '---'}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.createdAt")}
                            text={formatToSpanishTimeZone(
                              incidentData.createdAt
                            )}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.category")}
                            text={incidentData.category}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.informantType")}
                            type={"text"}
                            text={incidentData.informantType}
                            readOnly={true}
                            onChange={(e) => { }}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.userName")}
                            text={incidentData.userName}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                    </CommonCard>
                    <CommonCard
                      title={tIncidents("dataForm.title2")}
                      icon={"FaCircleInfo"}
                    >
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.titleIncident")}
                            text={incidentData.title}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("dataForm.incidentDate")}
                            text={incidentData.incidentDate}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        {incidentData?.customQuestions?.map((question, index) =>
                          <Col md={6}>
                            <FormCard
                              title={question.question}
                              text={question.response}
                              type={"text"}
                              readOnly
                            />
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormCard
                            title={tIncidents("dataForm.description")}
                            text={incidentData.description}
                            type={"textarea"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <div className="text-center mt-4">
                        {incidentData?.fileData ?
                          <Button
                            variant="secondary custom-shadow"
                            className=" custom-button-secondary m-auto "
                            disabled={!incidentData?.fileData}
                            onClick={() =>
                              downloadDoc(
                                incidentData.fileMimeType,
                                incidentData.fileData,
                                incidentData.incidentKey
                              )
                            }
                          >
                            {tIncidents("dataForm.downloadDocButton")}
                          </Button>
                          :
                          null
                        }
                        {incidentData?.audio ?
                          <Button
                            variant="secondary custom-shadow"
                            className="custom-button-secondary m-auto background-gradient"
                            disabled={!incidentData?.audio}
                            onClick={() =>
                              setShowPlayPopup(true)
                            }
                          >
                            {tIncidents("dataForm.playAudioButton")}
                          </Button>
                          :
                          null
                        }

                      </div>
                    </CommonCard>
                  </Col>
                  {/* Segundo CommonCard */}

                  {/* Tercer CommonCard */}
                  <Col md={12}>
                    <CommonCard title={tIncidents("incidentActivityTable.title")} icon={"FaFileDownload"}>
                      {incidentData &&
                        incidentData.incidentActivities &&
                        incidentData.incidentActivities.length > 0 ? (
                        <CustomTable
                          columnHeaders={columnHeaders}
                          fieldsToShow={fieldsToShow}
                          data={docsFromIncident}
                          optionArrays={optionArrays}
                          defaultFilterField={'createdAt'}
                          defaultFilterDirection={'desc'}
                          //loading={loading}
                          downloadButton
                          editButton={false}
                          displayFilter={false}
                        />
                      ) : (
                        <p></p>
                      )}

                    </CommonCard>
                  </Col>
                </Row>
              </Col>
              {/* Columna principal para el Col md={4} */}
              <Col md={5}>
                <Row>
                  <Col md={12}>
                    <CommonCard title={tIncidents("situationForm.title")} icon={"FaDatabase"}>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("situationForm.limitDateAd")}
                            text={addDaysAndFormat(incidentData.createdAt, 7)}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("situationForm.limitDateRes")}
                            text={addDaysAndFormat(incidentData.createdAt, 90)}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("situationForm.state")}
                            type={"text"}
                            text={incidentData.state}
                            readOnly={true}
                            onChange={(e) => { }}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={tIncidents("situationForm.responsible")}
                            text={incidentData.responsible}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                    </CommonCard>
                  </Col>
                  {/* Tercer CommonCard más pequeño */}
                  <Col md={12}>
                    <CommonCard
                      title={tIncidents("histoyTable.title")}
                      icon={"FaClock"}
                      actividad={
                        incidentData.stateId !== "ac41947f-2b62-45bc-a156-4774846c58a0" && incidentData.stateId !== "ce3e3338-e90b-4999-82f7-aa965824a62f" ? true : false
                      }
                    >

                      <Row>
                        {incidentData &&
                          incidentData.incidentActivities &&
                          incidentData.incidentActivities.length > 0 ? (
                          <TimeLine
                            items={incidentData.incidentActivities}
                            user={true}
                            incidentKey={incidentData.key}
                          />
                        ) : (
                          <p>{tIncidents("histoyTable.noActivities")}</p>
                        )}
                      </Row>
                    </CommonCard>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ConsultIncident;
